import { useState, useEffect, useCallback } from 'react'

export const useScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0,
    )

    const handleResize = useCallback(() => {
        setScreenWidth(window.innerWidth)
    }, [])

    useEffect(() => {
        window.addEventListener('resize', handleResize)

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [handleResize])

    return screenWidth
}
